Apt.fn.make('common', {
	/**
	 * Initialize common page functionality
	 */
	init: function() {
		Apt.header.init();
		Apt.footer.init();

		fetch('/nocache/dealerLogin')
			.then(res => res.text())
			.then(res => $$('header-dealer-link').text(res))
	},

	/**
	 * Execute required logic on every request
	 */
	setup: function() {
		var priv = this.$private;

		if ($._win.crawler) {
			return;
		}

		CF.util.idle([
			priv.initHistory,
			function() {
				Apt.wishlists.fetch();
			}
		], priv);

		$.supported('touch', {
			callback: function() {
				$._html.classList.remove('-c');
			}
		});
	}
}, {
	/**
	 * Initialize History navigation
	 */
	initHistory: function() {
		var $body = $($._body),
			$header = $$('header'),
			historyClass = '-is-replacing';

		$.history.init({
			bind: true,
			processErrors: true,
			partials: 'main, [data-ref="footer-newsletter"]',
			begin: function() {
				$header.removeClass('-is-expanded');
				$body.addClass(historyClass);
			},
			end: function() {
				requestAnimationFrame(function() {
					$body.removeClass(historyClass);

					fetch('/nocache/dealerLogin')
						.then(res => res.text())
						.then(res => $$('header-dealer-link').text(res))
				});
			}
		});
	}
});